
// Track played games for non-authenticated users
export const getPlayedGamesCount = (): number => {
  const count = localStorage.getItem('craveSOS_playedGamesCount');
  return count ? parseInt(count, 0) : 0;
};

export const incrementPlayedGamesCount = (): number => {
  const currentCount = getPlayedGamesCount();
  const newCount = currentCount + 1;
  localStorage.setItem('craveSOS_playedGamesCount', newCount.toString());
  return newCount;
};

export const resetPlayedGamesCount = (): void => {
  localStorage.setItem('craveSOS_playedGamesCount', '0');
};

// Session tracking
export const saveSessionProgress = (gameId: number, timeSpent: number): void => {
  const key = `craveSOS_game_${gameId}`;
  localStorage.setItem(key, timeSpent.toString());
};

export const getSessionProgress = (gameId: number): number => {
  const key = `craveSOS_game_${gameId}`;
  const timeSpent = localStorage.getItem(key);
  return timeSpent ? parseInt(timeSpent, 0) : 0;
};

// User preference tracking (for non-authenticated users)
export const saveUserPreference = (key: string, value: string): void => {
  localStorage.setItem(`craveSOS_pref_${key}`, value);
};

export const getUserPreference = (key: string): string | null => {
  return localStorage.getItem(`craveSOS_pref_${key}`);
};
